{
  "property_type": "क्या आप अपार्टमेंट, विला या इंडिपेंडेंट हाउस खोज रहे हैं?",
  "city": "आप किस शहर में संपत्ति खोज रहे हैं?",
  "city_or_locality": "आप किस शहर या इलाके में खोज रहे हैं?",
  "bedrooms": "आपको कितने बेडरूम (BHK) चाहिए?",
  "carpet_area": "आप कितने वर्ग फुट का कार्पेट एरिया चाहते हैं?",
  "plot_size": "आप किस आकार का प्लॉट चाहते हैं?",
  "budget": "आपका बजट क्या है?",
  "generic": "कृपया {{field}} बताएं।",
  "_generic_follow_up": "कृपया बताएं कि आप किस तरह की संपत्ति खोज रहे हैं।"
}
